module.exports = __webpack_public_path__ + "static/media/paidprogram.7f008287.svg";